







































































































































import RruleInput from '@/components/rrule-input.vue'
import SourceSelectInput from '@/components/source-select-input.vue'
import { ProgramRepository } from '@/core/api/programs'
import { fetchSpeechBackends } from '@/core/api/speech-backends'
import { StreamRepository } from '@/core/api/streams'
import { fetchYandexTokens } from '@/core/api/yandex-tokens'
import { CRUDMixinFactory } from '@/core/crud-mixin'
import { EventBus } from '@/core/events'
import Vue from 'vue'

const CRUDMixin = CRUDMixinFactory(new ProgramRepository(), EventBus)

export default Vue.extend({
  components: {
    SourceSelectInput,
    RruleInput,
  },
  data: () => ({
    item: null as any,
    streams: [],
    errors: {},
    tokens: [],
    speechBackends: [],
  }),
  async mounted() {
    const id = this.$route.params.id
    this.item = await this.getOrCreate(id, {
      source: {},
      streams: [],
      rrule:
        'RRULE:FREQ=DAILY;COUNT=10;INTERVAL=1;WKST=MO;BYDAY=MO,TU,WE,TH,FR,SA,SU;BYHOUR=0;BYMINUTE=0;BYSECOND=0',
    })
    this.fetchStreams()
    this.fetchYandexTokens()
    this.speechBackends = await fetchSpeechBackends()
  },
  methods: {
    async getOrCreate(id, defaults) {
      if (id == null) {
        return defaults
      }

      return this.fetch(id).then(item => {
        return item
      })
    },
    async fetchStreams() {
      new StreamRepository().$getPage(1, { 'page_size': 1000 }).then(response => {
        this.streams = response.results
      })
    },
    async fetchYandexTokens() {
      const resp = await fetchYandexTokens()
      this.tokens = resp['results']
    },
    onDeleteClick() {
      this.delete(this.item).then(() => {
        this.goBack()
      })
    },
    onCopyClick() {
      const duplicate = {
        ...this.item,
        id: null,
        name: this.item.name + ' (Копия)',
        source: this.item.source.id,
      }
      this.save(duplicate).then(data => {
        this.item = data
        this.$router.push({ name: 'ProgramEdit', params: { id: data.id } })
      })
    },
    onSaveClick() {
      this.save({ ...this.item, source: this.item.source.id })
        .then(data => {
          this.item = data
        })
        .catch(error => {
          this.errors = error.response?.data || {}
        })
    },
    onRRuleChange(value) {
      this.item.rrule = value
    },
    goBack() {
      this.$router.push({ name: 'ProgramList' })
    },
    ...CRUDMixin,
  },
})
